import GalleryImage from './GalleryImage';
export default GalleryImage;
